import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

import { login } from "../../login.actions";
import { Input } from "../../../../components/input/Input";
import { Button } from "../../../../components/button/Button";

import "./CommonLogin.scss";

export const CommonLogin = () => {
  const [username, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (username) {
      dispatch(login(username, password));
    }
  };

  return (
    <form
      className="common-login login-form col-md-6 col-lg-4"
      method="post"
      onSubmit={handleSubmit}
    >
      <h1 className="login__header">
        <FormattedMessage id="account_login" />
      </h1>
      <Input
        id={"inputUsername"}
        autoCapitalize="none"
        onChange={(e) => setUserName(e.target.value)}
        value={username}
        label={<FormattedMessage id={"username"} />}
      />
      <Input
        id={"inputPassword"}
        type={"password"}
        autoCapitalize="none"
        onChange={(e) => setPassword(e.target.value)}
        value={password}
        label={<FormattedMessage id={"password"} />}
      />
      <Button type="submit" className="login-form__button" size="large">
        <FormattedMessage id="login" />
      </Button>
    </form>
  );
};
